module.exports = __webpack_public_path__ + "img/doctor-avatar3.c4230f63.png";